module.exports = __webpack_public_path__ + "static/media/chevron-right-double.d56f7b14.svg";